import type { ReactElement } from 'react';

import logoOnLightUrl from '../assets/moqeem-logo.png';
import logoOnDarkUrl from '../assets/moqeem-logo-white.png';

export function BrandLogo({
  alt,
  className = '',
  surface = 'adaptive',
}: {
  alt: string;
  className?: string;
  surface?: 'adaptive' | 'dark';
}): ReactElement {
  const classes = ['brand-logo-lockup', `brand-logo-lockup--${surface}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} role="img" aria-label={alt}>
      <img className="brand-logo-lockup__on-light" src={logoOnLightUrl} alt="" />
      <img className="brand-logo-lockup__on-dark" src={logoOnDarkUrl} alt="" />
    </span>
  );
}
